import CreatorsDataTable from '../components/CreatorsDataTable';
import SEO from '../components/SEO';

export default function USCreators() {
  return (
    <div className="flex-1 bg-white py-12">
      <SEO
        title="Top US Travel Creators & Influencers | Waybook"
        description="Discover the best travel content creators and influencers from the United States. Get inspired by American travel experiences and destinations."
        keywords="US travel creators, American travel influencers, USA travel bloggers, United States travel content"
        canonicalUrl="https://www.waybook.me/recommended/us"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: 'United States Travel Creators',
          description: 'Top travel content creators from the United States',
          url: 'https://www.waybook.me/recommended/us'
        }}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold mb-4">🇺🇸 United States Travel Creators</h1>
        <p className="text-gray-600 mb-8">
          Discover the best travel content creators from the United States
        </p>
        <CreatorsDataTable 
          countryFilter="US"
          showFilters={false}
          title="US Creators"
          limit={20}
        />
      </div>
    </div>
  );
}
